import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {BoxTitle} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/area/BoxTitle';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SurfaceSelectionFrame.less');
const cx = classnames.bind(styles);

@observer
export class SurfaceSelectionFrame extends React.Component<any, any>
{
    public render():JSX.Element
    {
        const {surfaceArea, surfaceSelection, surfaceBoxReparenting, surfaceDrawingComponent} = controllers.ui;
        const {area: {zoom}} = rootState.ui.visualDesigner.surfaceEditor;

        const isCursorSelectionEnabled = surfaceSelection.isCursorSelectionEnabled();
        const isDrawingComponentEnabled = surfaceDrawingComponent.isDrawingComponentEnabled();

        if( isDrawingComponentEnabled )
            return null;

        if( isCursorSelectionEnabled )
        {
            const {x, y, width, height} = surfaceSelection.getSelectionBounds(true);

            return (
                <div
                    className={cx('base')}
                    style={{
                        left: `${x}px`,
                        top: `${y}px`,
                        width: `${width}px`,
                        height: `${height}px`
                    }}
                />
            );
        }

        if( surfaceSelection.areMultipleBoxesSelected() && surfaceSelection.isAllSelectedBoxesInSelfDirectedLayout() )
        {
            const selectedBoxes = surfaceSelection.getSelectedBoxes();
            const {x, y, width, height} = surfaceArea.getBoxesBounds(selectedBoxes, true);
            const isReparenting:boolean = surfaceBoxReparenting.isBoxReparentingEnabled();

            const boxTitleClassName:string = isReparenting ? cx('pointerEventsNone') : null;

            return (
                <div
                    className={cx('base', {isReparenting})}
                    style={{
                        left: `${x}px`,
                        top: `${y}px`,
                        width: `${width}px`,
                        height: `${height}px`,
                        pointerEvents: 'none'
                    }}
                    data-component="selected-component"
                >
                    <BoxTitle
                        className={boxTitleClassName}
                        displayName={'Group'} style={{zoom: 1 / zoom}}
                    />
                </div>
            );
        }

        return null;
    }
}
